export {
    encodeByte,
    encodeByteSlice,
    encodeInt8,
    encodeInt16,
    encodeInt32,
    encodeInt64,
    encodeVarint,
    encodeUint8,
    encodeUint16,
    encodeUint32,
    encodeUint64,
    encodeUvarint,
    encodeFloat32,
    encodeFloat64,
    encodeBool,
    encodeString,
    encodeTime
} from '../lib/Amino';
